import { NgModule } from '@angular/core';
import { FilterlistPipe } from './filterlist.pipe';

@NgModule({
    declarations: [FilterlistPipe],
    exports: [FilterlistPipe],
})
export class FilterlistPipeModule {}
